import { getRemotes } from './contract/api'

const getenvironment = async () => {
  console.log('GET REMOTES')
  const r = await getRemotes()

  window.SCENARIOS_URL = r.SCENARIOS_URL
  window.APP_FRAME_URL = r.APP_FRAME_URL
  window.STYLE_URL = r.STYLE_URL

  import('./bootstrap')
}

getenvironment()
